import { Navigate, useParams } from 'react-router-dom'
import ContentPage from '@/components/ContentPage'
import { getCardReader } from '@/content/cardReaders'

export default function CardReaderDetailPage() {
  const { slug } = useParams()
  const reader = getCardReader(slug)

  if (!reader) {
    return <Navigate to="/card-readers" replace />
  }

  return (
    <ContentPage
      path={reader.path}
      seoTitle={reader.seoTitle}
      seoDescription={reader.seoDescription}
      heroTitle={reader.name}
      heroDescription={reader.intro}
      images={reader.images}
      eyebrow="Card readers"
      sections={reader.sections}
      relatedFeatureSlugs={reader.relatedFeatureSlugs}
    />
  )
}
